import React from "react";
import { View, Text, StyleSheet, TouchableOpacity } from "react-native";
import Colors from "../../../constants/Colors";
import { useSelector, useDispatch } from "react-redux";
import DefaultText from "../../../components/text/DefaultText";
import { Ionicons } from "@expo/vector-icons";
import * as deviceActions from "../../../store/actions/device";
import NFTS from "../../../data/dummy_data";
import { useNavigation } from "@react-navigation/native";
import DefaultTextBold from "../../../components/text/DefaultTextBold";
import * as userNftActions from "../../../store/actions/userNft";
import * as userDeviceActions from "../../../store/actions/device";

const AddArtworkScreen = (props) => {
  const navigation = useNavigation();

  const dispatch = useDispatch();

  const newNfts = NFTS;

  return (
    <View style={styles.screen}>
      <TouchableOpacity
        onPress={() => {
          //dispatch(userNftActions.resetNftDatabase());
          //dispatch(userDeviceActions.resetDeviceDatabase());
        }}
      >
        <Ionicons name="add-outline" size={50} color="white" />
      </TouchableOpacity>
      <View style={styles.textContainer}>
        <DefaultText style={{ fontSize: 30 }}>Add NFT</DefaultText>
      </View>
      {/*FIXME  <TouchableOpacity
        style={styles.buttonContainer}
        onPress={() => {
          navigation.navigate("CreateArtScreen");
        }}
      >
        <Text style={styles.pairText}>Upload from Library</Text>
      </TouchableOpacity> */}
      <TouchableOpacity
        style={styles.buttonContainer}
        onPress={() => {
          navigation.navigate("AddArtworkETHScreen");
        }}
      >
        <Text style={styles.pairText}>Enter Ethereum Public Address</Text>
      </TouchableOpacity>
      {/* </View> */}
    </View>
  );
};

const styles = StyleSheet.create({
  screen: {
    flex: 1,
    backgroundColor: "black",
    alignItems: "center",
    justifyContent: "center",
  },
  textContainer: {
    padding: 5,
  },
  buttonContainer: {
    backgroundColor: "white",
    width: "90%",
    height: 48,
    alignItems: "center",
    justifyContent: "center",
    margin: 12,
  },
  pairText: {},

  pairButton: {},
});

export default AddArtworkScreen;
